import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { Grid, Switch } from '@material-ui/core';
import AddEditDomain from './AddEditDomain';
import { useSelector, useDispatch } from 'react-redux';
import MsgBox from 'components/MsgBox/MsgBox';
import CustomTable from 'components/CustomTable';
import CustomButton from 'components/CustomInput/Button/index';
import {
    SYSTEM_DELETE_EMAIL_DOMAIN,
    SYSTEM_EDIT_EMAIL_DOMAIN,
    GET_EMAIL_DOMAIN_LIST,
    UPDATE_EMAIL_DOMAIN,
} from 'store/key';
import { getTimeWithTimeZone } from 'utility/general';
import useDialog from 'components/ConfirmDialog/useDialog';
import { EMAIL_DOMAIN_CREATED, EMAIL_DOMAIN_DELETED } from 'utility/frontendMessage';
import { getSystemMessage } from 'store/system/systemMessageReducer';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
    title: {
        marginRight: theme.spacing(4),
        fontWeight: 'bold',
    },
    tableContanier: {
        marginTop: theme.spacing(2),
    },
}));

const EmailDomain = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const showDialog = useDialog();

    const emailDomainList = useSelector((state) => state.emailDomain.emailDomainList);
    const isLoading = useSelector((state) => state.emailDomain.isLoading);

    const columns = [
        {
            field: 'enable',
            headerName: 'Enable',
            sortable: false,
            width: 80,
            renderCell: (params) => {
                return (
                    <Switch
                        size="small"
                        color="primary"
                        checked={params.row.enable}
                        onChange={(e) => changeEnable(params.row)}
                    />
                );
            },
        },
        { field: 'email', headerName: 'Domain', width: 280 },
        {
            field: 'createDtm',
            headerName: 'Created Date',
            width: 180,
            valueGetter: (params) => {
                return getTimeWithTimeZone(params.value).format('YYYY-MM-DD');
            },
        },
    ];

    const rows = emailDomainList;
    const [selectedRow, setSelectedRow] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [warningMsg, setWarningMsg] = useState(null);

    const getEmailDomains = () => {
        dispatch({
            type: GET_EMAIL_DOMAIN_LIST,
            payload: null,
        });
    };

    useEffect(() => {
        getEmailDomains();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const changeEnable = (row) => {
        setWarningMsg({
            type: 'confirm',
            message: getSystemMessage('disableEnableAcc', [row.enable ? 'disable' : 'enable']),
            footerActions: [
                {
                    label: 'Cancel',
                    color: 'default',
                    clicked: () => {
                        setWarningMsg(null);
                    },
                },
                {
                    label: 'Confirm',
                    clicked: () => {
                        dispatch({
                            type: UPDATE_EMAIL_DOMAIN,
                            payload: {
                                row: {
                                    email: row.domain,
                                    enable: !row.enable,
                                    id: row.id,
                                },
                                callback: () => {
                                    showDialog({
                                        description: EMAIL_DOMAIN_CREATED,
                                        disableCancelButton: true,
                                    });
                                    dispatch({
                                        type: SYSTEM_EDIT_EMAIL_DOMAIN,
                                        payload: { ...row, enable: !row.enable },
                                    });
                                },
                            },
                        });

                        setWarningMsg(null);
                    },
                },
            ],
        });
    };

    const handleEdit = (row) => {
        setSelectedRow(row);
        setOpenPopup(true);
    };
    const editRow = (row) => {
        getEmailDomains();
    };
    const deleteRow = (row) => {
        dispatch({
            type: SYSTEM_DELETE_EMAIL_DOMAIN,
            payload: {
                id: row.id,
                callback: () => {
                    showDialog({
                        description: EMAIL_DOMAIN_DELETED,
                        disableCancelButton: true,
                    });
                    getEmailDomains();
                },
            },
        });
    };
    const handleAdd = () => {
        setSelectedRow(null);
        setOpenPopup(true);
    };
    const createUser = (row) => {
        dispatch({
            type: GET_EMAIL_DOMAIN_LIST,
            payload: null,
        });
    };
    return (
        <Grid container wrap="nowrap" direction="column" className={classes.root}>
            {warningMsg ? (
                <MsgBox
                    type={warningMsg.type}
                    message={warningMsg.message}
                    footerActions={warningMsg.footerActions}
                    title={warningMsg.title}
                    closePopup={() => setWarningMsg(null)}
                />
            ) : null}
            {openPopup ? (
                <AddEditDomain
                    selectedRow={selectedRow}
                    editRow={editRow}
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                    createUser={createUser}
                />
            ) : null}
            <Grid container wrap="nowrap" alignItems="center">
                <Typography className={classes.title}>Authorized Email Domain:</Typography>
                <CustomButton onClick={handleAdd}>Add</CustomButton>
            </Grid>
            <Grid className={classes.tableContanier} container>
                <CustomTable
                    isDeleteAllow
                    isEditAllow
                    onEdit={handleEdit}
                    onDelete={deleteRow}
                    columns={columns}
                    rows={rows}
                    allowResize
                    skipMaxHeight
                    fullWidthTable={false}
                    loading={isLoading}
                />
            </Grid>
        </Grid>
    );
};

export default EmailDomain;
